import { set } from 'lodash/fp';
import createReducer from '../../../../helpers/createReducer';
import {
  paginationState,
  resetPaginationState
} from '../../../../helpers/pagination';
import {
  createFetchOneHandler,
  createFetchManyHandler,
  createSaveHandler,
  createUpdateHandler,
  createDeleteHandler
} from '../../../../helpers/reducerRoutineCrudHandler';
import {
  fetchInventoryPackage,
  fetchInventoryPackages,
  createInventoryPackage,
  updateInventoryPackage,
  deleteInventoryPackage
} from '../../sagas/routines';
import {
  clearInventoryPackages,
  inventoryPackagesOnChangePage,
  resetInventoryPackageDeleted,
  inventoryPackagesOnChangeOrder
} from '../../actions/package';

const initialState = {
  all: {},
  fetched: false,
  fetching: false,
  fetchingError: null,
  saved: false,
  saving: false,
  savingError: null,
  deleted: false,
  deleting: false,
  deletingError: null,
  pagination: paginationState(),
  order: 'id:desc'
};

const clearPackagesHandler = action => ({
  [action.toString()]: state => ({
    ...state,
    all: {},
    pagination: resetPaginationState(state.pagination)
  })
});

const inventoryPackagesOnChangePageHandler = action => ({
  [action.toString()]: (state, { payload: page }) =>
    set('pagination.currentPage', page, state)
});

const updateInventoryPackagesOnChangeOrderHandler = action => ({
  [action.toString()]: (state, { payload: order }) => set('order', order, state)
});

const resetDeletedHandler = action => ({
  [action.toString()]: set('deleted', false)
});

export default createReducer(initialState, {
  ...createFetchOneHandler(fetchInventoryPackage),
  ...createFetchManyHandler(fetchInventoryPackages),
  ...createSaveHandler(createInventoryPackage),
  ...createUpdateHandler(updateInventoryPackage),
  ...createDeleteHandler(deleteInventoryPackage),
  ...resetDeletedHandler(resetInventoryPackageDeleted),
  ...clearPackagesHandler(clearInventoryPackages),
  ...inventoryPackagesOnChangePageHandler(inventoryPackagesOnChangePage),
  ...updateInventoryPackagesOnChangeOrderHandler(inventoryPackagesOnChangeOrder)
});
